type DemoPrompt = {
  label: string;
  prompt: string;
};

const DEMO_PROMPTS: DemoPrompt[] = [
  { label: "NVDA news", prompt: "Show me the latest news about NVDA." },
  {
    label: "Consumer Cyclical",
    prompt: "What news is there today in the Consumer Cyclical sector?",
  },
  {
    label: "War Influence",
    prompt: "How Middle east war will effect todays' market sentiment, show a heat map",
  },
  {
    label: "TSLA 1W trend",
    prompt: "How has TSLA moved over the past week? Show the 1-week price trend.",
  },
  {
    label: "Find Stocks",
    prompt: "Help me find some NASDAQ-listed stocks related to embodied AI or robotics.",
  },
];

export function DemoPrompts({
  onSelectPrompt,
}: {
  onSelectPrompt: (prompt: string) => void;
}) {
  return (
    <div className="mt-4 flex flex-wrap justify-center gap-2 px-4">
      {DEMO_PROMPTS.map((item) => (
        <button
          key={item.label}
          type="button"
          onClick={() => onSelectPrompt(item.prompt)}
          className="rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-medium text-slate-700 shadow-sm transition-colors hover:bg-slate-50 active:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/30"
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
